import React, { useContext, useEffect } from "react";
import TitleContext from "../../context/TitleContext";
import CreateCompanyWithAdminComponent from "../../components/superAdmin/CreateCompanyWithAdmin";
const CreateCompanyPage = () => {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("Create Company");
  }, [setTitle]);

  return (
    <>
      <CreateCompanyWithAdminComponent />
    </>
  );
};
export default CreateCompanyPage;
